import store from '../../store';
import i18n from '@/i18n';
import { isNonEmptyArr, isNonEmptyStr } from '../../utils';

export default [
  {
    path: '/',
    component: () => import('../../views/auth/Base.vue'),
    children: [
      {
        path: 'login',
        name: 'login',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          title: i18n.global.t('login')
        },
        component: () => import('../../views/auth/Login.vue'),
      },
      {
        path: 'password/reset',
        name: 'forgot-pass',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          title: i18n.global.t('reset_password')
        },
        component: () => import('../../views/auth/ForgotPass.vue'),
      },
      {
        path: 'password/reset/:token/:email',
        name: 'reset-pass',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          isTokenProtected: true,
          title: i18n.global.t('set_password')
        },
        component: () => import('../../views/auth/ResetPass.vue'),
        beforeEnter: (to, from, next) => {
          const { token, email } = to.params;

          return store
            .dispatch('auth/isValidPassResetToken', { token, email })
            .then((res) => {
              if (!res) {
                return next('/login');
              }

              return next();
            });
        },
      },
      {
        path: 'password/request/:token',
        name: 'set-pass',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          isTokenProtected: true,
          title: i18n.global.t('reset_password')
        },
        component: () => import('../../views/auth/SetPass.vue'),
        beforeEnter: (to, from, next) => {
          const { token } = to.params;

          return store
            .dispatch('auth/isValidPassSetToken', { token })
            .then((res) => {
              if (!res) {
                return next('/login');
              }

              return next();
            });
        },
      },
      {
        path: 'register',
        name: 'register',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          title: i18n.global.t('sign_up')
        },
        component: () => import('../../views/auth/RegisterNewAccount.vue'),
      },
      {
        path: 'register/new/:token',
        name: 'register-new',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          isTokenProtected: true,
          title: i18n.global.t('join_account')
        },
        component: () => import('../../views/auth/Register.vue'),
        beforeEnter: (to, from, next) => {
          const { token } = to.params;

          return store
            .dispatch('auth/isValidRegistrationToken', token)
            .then((res) => {
              const { businesses } = res.data.data;

              if (!isNonEmptyArr(businesses)) {
                return next();
              }

              return next(`/register/second/${token}`);
            })
            .catch(() => next('/login'));
        },
      },
      {
        path: 'register/invited/:token',
        name: 'register-invited',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          isTokenProtected: true,
          title: i18n.global.t('new_registration')
        },
        component: () => import('../../views/auth/Invite.vue'),
        beforeEnter: (to, from, next) => {
          const { token } = to.params;

          return store
            .dispatch('auth/isValidInvitationToken', token)
            .then((res) => {
              const { business } = res.data.data;

              if (isNonEmptyStr(business)) {
                return next();
              }

              return next('/login');
            })
            .catch(() => next('/login'));
        },
      },
      {
        path: 'register/second/:token',
        name: 'register-second',
        meta: {
          loadState: true,
          auth: false,
          isAuthPage: true,
          isTokenProtected: true,
          title: i18n.global.t('accept_invitation')
        },
        component: () => import('../../views/auth/JoinAccount.vue'),
        beforeEnter: (to, from, next) => {
          const { token } = to.params;

          return store
            .dispatch('auth/isValidRegistrationToken', token)
            .then((res) => {
              const { businesses } = res.data.data;

              if (isNonEmptyArr(businesses)) {
                return next();
              }

              return next(`/register/new/${token}`);
            })
            .catch(() => next('/login'));
        },
      },
    ]
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      loadState: false,
      auth: true,
      isAuthPage: true,
      title: i18n.global.t('sign_out')
    },
    component: () => import('../../views/auth/Logout.vue'),
  },
];
